import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\LinkWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/LinkWikiItemToItemControlleur.php
* @route '/api/item/{item}/link-wiki-item/{wiki_item_id}'
*/
const LinkWikiItemToItemControlleur = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkWikiItemToItemControlleur.url(args, options),
    method: 'post',
})

LinkWikiItemToItemControlleur.definition = {
    methods: ["post"],
    url: '/api/item/{item}/link-wiki-item/{wiki_item_id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\LinkWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/LinkWikiItemToItemControlleur.php
* @route '/api/item/{item}/link-wiki-item/{wiki_item_id}'
*/
LinkWikiItemToItemControlleur.url = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            wiki_item_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        wiki_item_id: args.wiki_item_id,
    }

    return LinkWikiItemToItemControlleur.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{wiki_item_id}', parsedArgs.wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\LinkWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/LinkWikiItemToItemControlleur.php
* @route '/api/item/{item}/link-wiki-item/{wiki_item_id}'
*/
LinkWikiItemToItemControlleur.post = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkWikiItemToItemControlleur.url(args, options),
    method: 'post',
})

export default LinkWikiItemToItemControlleur